/** Останні помилки сторінки (window.onerror, необроблені проміси) — додаються до звіту про проблему, щоб розробнику
 * не доводилось їх ловити. Лише в памʼяті вкладки, нікуди не надсилаються самі. */
const MAX = 10;
const buf: string[] = [];

function push(s: string) {
  buf.push(`${new Date().toISOString().slice(11, 19)} ${s}`.slice(0, 500));
  if (buf.length > MAX) buf.shift();
}

export function installErrorBuffer(): void {
  if (typeof window === 'undefined') return;
  window.addEventListener('error', (e) => push(`${e.message}${e.filename ? ` @ ${e.filename}:${e.lineno}` : ''}`));
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason as { message?: string } | string | undefined;
    push(`unhandled: ${typeof r === 'string' ? r : r?.message ?? String(r)}`);
  });
}

/** Помилки API (статус і шлях) теж корисні у звіті — клієнт викликає це на кожну відповідь з помилкою. */
export function noteApiError(method: string, path: string, status: number, code?: string): void {
  push(`api ${method} ${path} → ${status}${code ? ` ${code}` : ''}`);
}

export function recentErrors(): string[] {
  return [...buf];
}
